import { LicenseMonthlySubscriptionTrialSubFormWebComponent } from './component/LicenseMonthlySubscriptionTrialSubFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_SUBSCRIPTION_TRIAL_SUBFORM } from '../../webcomponents.constants';

export { LicenseMonthlySubscriptionTrialSubFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_LICENSE_MONTHLY_SUBSCRIPTION_TRIAL_SUBFORM,
  LicenseMonthlySubscriptionTrialSubFormWebComponent
);
